import { Typography } from '@material-ui/core';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import { MenuItem } from 'components/EllipsisMenu';
import React from 'react';
import styled from 'styled-components';
import { useShiftableClick } from '../../../hooks/useShiftableClick';
import { ProgressionTypes } from '../../../utils/activityPlan';
import { CopyToClipboardButtonIcon } from '../../CopyToClipboardButtonIcon';
import { ProgressionHeader } from '../ProgressionHeader';

export interface PerisurgicalWeekHeaderProps {
  id: string;
  week: number;
  current?: boolean | null;
  expanded: boolean;
  estimatedTime: number;
  canCopyExercises: boolean;
  onToggleCollapse: () => void;
  onCopyUniqueExercises: () => void;
  onCopyAllExercises: () => void;
  menuItems?: MenuItem[];
}

const ChildWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ChildTypography = styled(Typography)`
  margin-left: 0.3rem;
`;

export const PerisurgicalWeekHeader = ({
  id,
  week,
  current,
  expanded,
  onToggleCollapse,
  estimatedTime,
  onCopyUniqueExercises,
  onCopyAllExercises,
  canCopyExercises,
  menuItems
}: PerisurgicalWeekHeaderProps): JSX.Element => {
  const durationLabel = `${estimatedTime} minutes`;
  const title = `${ProgressionTypes.perisurgical} ${week}`;

  const handleCopyExercisesToClipboard = useShiftableClick({
    onClick: onCopyAllExercises,
    onShiftClick: onCopyUniqueExercises
  });

  return (
    <ProgressionHeader
      id={id}
      title={title}
      expanded={expanded}
      onToggleCollapse={onToggleCollapse}
      centerProps={{ gap: 4, justifyContent: 'flex-end' }}
      menuItems={menuItems}
      current={current}
    >
      <ChildWrapper>
        <AvTimerIcon />
        <ChildTypography variant="caption">{durationLabel}</ChildTypography>
      </ChildWrapper>

      <CopyToClipboardButtonIcon
        onClick={handleCopyExercisesToClipboard}
        title={`Copy ${ProgressionTypes.acute} ${week} exercises to clipboard`}
        testId="copyWeekButton"
        disabled={!canCopyExercises}
      />
    </ProgressionHeader>
  );
};
